import { Box } from '@chakra-ui/react';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import { useCustomersContext } from '../context';
import CustomerCard from './CustomerCard';

const List = () => {
  const {
    getCustomers,
    customers,
    totalPages,
    loading,
  } = useCustomersContext();

  if (loading) return <Loading />;

  if (customers.length === 0) {
    return (
      <Box textAlign="center" mt={20} color="gray.500">
        Nenhum cliente encontrado.
      </Box>
    );
  }

  return (
    <PaginationRouterContainer
      total={totalPages}
      onPaginationChange={getCustomers}
    >
      {customers.map((customer) => (
        <CustomerCard
          key={customer.id}
          customer={customer}
          refetch={() => getCustomers({})}
        />
      ))}
    </PaginationRouterContainer>
  );
};

export default List;
